<div class="incubatee-div-modal">
    <div class='form_div chart'>
        <div class='terms-head mb-3'>
            <div class='chart-det'>
                <div>
                    <h5 class='font-weight-bold mb-3'>Terms And Conditions</h5>
                </div>
            </div>
        </div>
        <form class="signin-form">
            <div class=''>
                <div class='col-lg-12 col-12'>
                    <div class='d-flex'>
                        <div class='mt-2'>
                            <ol>
                                <li>
                                    <div>
                                        I hereby confirm that
                                        <ul>
                                            <li>Host Institution Details are filled
                                            </li>
                                            <li>Track record of the institution is filled and endorsement certificate is provided as per the format
                                            </li>                                            
                                            <li>Pitchdeck for the EoI is attached
                                            </li>
                                            <li>Other necessary documents are attached wherever required
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    I hereby confirm that all the above information are checked and provide consent to
                                    StartupTN for further necessary action on the same

                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div class="center-btn-div">
                    <button class="mr-2 new-btn-color2" mat-raised-button color="warn"
                        (click)="cancelReg()">Close</button>
                    <button class="new-btn-color" mat-raised-button color="primary" (click)="submiteApi()">I
                        Accept</button>
                </div>
            </div>
        </form>
    </div>
</div>